<template>
  <form class="login-form" @submit.prevent="auth">
    <div class="card mb-0">
      <div class="card-body">
        <div class="text-center mb-3">
          <img src="@/assets/img/logo_mini.png" class="h-72px" alt="Logo" />
          <h5 class="mt-1 mb-0">Login</h5>
          <span class="text-muted">Entre com suas credenciais</span>
        </div>
        <div class="mb-3">
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': v$.login.$errors.length }"
              placeholder="E-mail ou Nome de Usuário"
              v-model="v$.login.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph-envelope text-muted" />
            </div>
            <span v-if="v$.login.required.$invalid" class="invalid-feedback">
              O campo é obrigatório
            </span>
          </div>
        </div>
        <div class="mb-3">
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="password"
              class="form-control"
              :class="{ 'is-invalid': v$.password.$errors.length }"
              placeholder="••••••••"
              v-model="v$.password.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph-lock text-muted" />
            </div>
            <span v-if="v$.password.required.$invalid" class="invalid-feedback">
              O campo é obrigatório
            </span>
            <span
              v-if="v$.password.minLength.$invalid"
              class="invalid-feedback"
            >
              A senha deve ter pelo menos
              {{ v$.password.minLength.$params.min }} caracteres
            </span>
          </div>
        </div>
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-primary w-100"
            title="Login"
            :disabled="v$.$invalid || disableButton"
          >
            <span v-if="disableButton">
              <i class="ph-spinner spinner" />
            </span>
            <span v-else>Login</span>
          </button>
        </div>
        <div class="text-center" title="Esqueceu sua senha?">
          <router-link to="/password-recovery">
            Esqueceu sua senha?
          </router-link>
        </div>
        <hr class="my-2" />
        <div class="text-center" title="Página Inicial">
          <router-link to="/">Página Inicial</router-link>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import PATHS from '@/router/routesMap'

export default {
  name: 'Auth',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      login: '',
      password: '',
      disableButton: false,
    }
  },

  methods: {
    async auth() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          await this.$store.dispatch('auth', {
            login: this.login,
            password: this.password,
          })
          this.disableButton = false
          this.$router.push(PATHS.HOME)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      login: {
        required,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    }
  },

  mounted() {
    if (localStorage.getItem('sessionError')) {
      this.$root.$refs.notification.warning(
        localStorage.getItem('sessionError'),
      )
      localStorage.removeItem('sessionError')
    }
  },
}
</script>
